// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2It7k","header":"MessagesList_header__3rBuC","chat":"MessagesList_chat__1hMUF"};